import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11.25,
			stroke: "#003764",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 9.5,
			r: 3.5,
			stroke: "#003764",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 20.7775C6.16667 18.4442 8.57778 16.1108 12 16.1108C15.4222 16.1108 17.8333 18.4442 19 20.7775",
			stroke: "#003764",
			strokeWidth: 1.5
		})
	]
});
export default SvgProfile;
